import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'loadingDetail': false,
  'downloadingExcel': false,
  'excelFileURL': '',
  'list': [],
  'detail': [],
};

const checkEmptyLogisticTotals = (totals) => {
  const sumTotals = totals.reduce(
    (accum, logisticIndice) => (accum += logisticIndice.total),
    0
  );

  return !sumTotals ? [] : totals;
};

export const logisticIndices = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_LOGISTIC_INDICES]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.FETCHING_LOGISTIC_INDICES]: (state, action) => ({
      ...state,
      'loading': true,
      'detail': [],
    }),
    [ActionTypes.FETCHED_LOGISTIC_INDICES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': checkEmptyLogisticTotals(action.response.data),
    }),
    [ActionTypes.FETCHED_LOGISTIC_INDICES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.FETCHING_LOGISTIC_INDICES_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.FETCHED_LOGISTIC_INDICES_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'detail': action.response.data,
    }),
    [ActionTypes.FETCHED_LOGISTIC_INDICES_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'detail': [],
    }),
    [ActionTypes.DOWNLOAD_LOGISTIC_INDICES_DETAILL_REQUEST]: (
      state,
      action
    ) => ({
      ...state,
      'downloadingExcel': true,
    }),
    [ActionTypes.DOWNLOAD_LOGISTIC_INDICES_DETAIL_SUCCESS]: (
      state,
      action
    ) => ({
      ...state,
      'downloadingExcel': false,
      'excelFileURL': action.response.data,
    }),
    [ActionTypes.DOWNLOAD_LOGISTIC_INDICES_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'downloadingExcel': false,
      'excelFileURL': '',
    }),
    [ActionTypes.CLEAR_LOGISTIC_INDICES_DETAIL_EXCEL_FILE]: (
      state,
      action
    ) => ({
      ...state,
      'excelFileURL': '',
    }),
  })(state, action);
};
